import { IonApp, IonPage, IonToolbar, IonButtons, IonMenuToggle, IonButton, IonContent
    } from '@ionic/react';
import { useEffect, useState  } from 'react';

import UserLogout from '../../../components/UserLogoutComponent';
import BookingComponent from './bookingComponent'

import { getMemberProfile } from "../services/apiService"

import '../../../styles/NewDeliveryComponent.css'
import '../../../styles/style.css'

function NewDeliveryComponent (props){ 
    const [memberData, setMemberData ] = useState({})
    const [selectedBookingType, setSelectedBookingType] = useState("pickUpNow")
    useEffect(()=>{
        getMemberData()
    }, [])

    const getMemberData = async () => {
       let data = await getMemberProfile()
       setMemberData(data)
    }

    

    return (
        <>
            <IonApp>
                <IonPage className="ion-page core-wrapper" id="main-content">
                    <IonToolbar className='header-toolbar'>
                        <IonButtons slot="start" className='home-btn'>
                            <IonMenuToggle>
                                <IonButton>
                                    <img src='../img/menu-icon.png' />
                                </IonButton>
                            </IonMenuToggle>
     
                        </IonButtons>
                        <img className='header-logo' src='../img/logo.png' />
                    </IonToolbar>


                    <IonContent className="ion-padding page-title">
                        <div className="wrapper dashboard-page  option-1 option-1-1">
                            <h1>Make A New Delivery</h1>
                           
                            <div className='payment desktop'>
                                <img src='../img/home-step.svg' />
                            </div>
                            <div className='payment mobile'>
                                <img src='../img/home-step.svg' />
                            </div>

                            <div className="tabs">
                                <div className='tab-header'>
                                    <div className="tab" >
                                        <input type="radio" className='first-tab' id="tab-1" name="tab-group-1" checked={selectedBookingType==="pickUpNow"} onClick={() => setSelectedBookingType("pickUpNow")}/>
                                        <label htmlFor="tab-1">
                                            <img src="img/picknow.svg"/>
                                            <h2>Pick up now</h2>
                                            <p>We will deliver within 50 minutes.</p>
                                            
                                        </label>
                                    </div>

                                    <div className="tab">
                                        <input type="radio" id="tab-2" name="tab-group-1" checked={selectedBookingType==="scheduledDelivery"} onClick={() => setSelectedBookingType("scheduledDelivery")}/>
                                        <label htmlFor="tab-2">
                                        <img src="img/pickup-later.svg"/>
                                            <h2>Schedule a delivery</h2>
                                            <p>We will arrive at address at your scheduled time.</p>
                                            
                                        </label>
                                    </div> 
                                </div>
                                <BookingComponent bookingType={selectedBookingType}/>


                            </div>
                        
                        
                        </div>



                    </IonContent>
                </IonPage>
            </IonApp>
        </>
    )
}

export default NewDeliveryComponent;